import React, {useState} from 'react';
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import Loading from "../feeback/loading/Loading";
import Card from "@mui/material/Card";
import {useTranslation} from "react-i18next";
import {Grid} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import {green} from '@mui/material/colors';
import {fetchConsumerLink} from "../../../store/actions/system/OAuth2Action";
import {connect} from 'react-redux'

const BankOAuth = ({consumerInfo, oauth = null, fetchConsumerLink}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false)
    const handleLink = () => {
        setLoading(true)
        fetchConsumerLink(consumerInfo.OAuth2_Consumer__, window.location.href)
            .then((d) => {
                window.location = d.redirect_url;
                setLoading(false)
            })
    }
    return (
        <Card variant='outlined'>
            <CardContent>
                <CardActionArea onClick={handleLink} disabled={oauth !== null}>
                    <CardHeader
                        action={
                            !loading ?
                                <Grid container spacing={3}>

                                    <Grid item>
                                        <img alt={consumerInfo.Name}
                                             src={consumerInfo.Logo}
                                             {...consumerInfo.LogoDisplay}
                                        />
                                    </Grid>

                                </Grid>
                                :
                                <Loading thickness={1}/>
                        }
                        title={
                            <Grid container direction="row" alignItems="center">
                                {oauth !== null && <Grid item>
                                    <CheckIcon style={{color: green[500]}}/>
                                </Grid>}
                                <Grid item>
                                    {t('store_bank_' + consumerInfo.Name)}
                                </Grid>
                            </Grid>

                        }
                        subheader={t(oauth === null ? 'store_bank_link_info' : 'store_bank_link_enabled')}
                    />
                </CardActionArea>
            </CardContent>
        </Card>
    );
};


const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchConsumerLink: (consumerID, returnTo) => dispatch(fetchConsumerLink(consumerID, returnTo))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BankOAuth);
